import {
  listCatalogs as publicListCatalogs,
  getMenu as publicGetMenu,
  getSection as publicGetSection,
  updateMenu as publicUpdateMenu,
  updateSection as publicUpdateSection,
  listMenus as publicListMenus,
  listSections as publicListSections,
  createMenu as publicCreateMenu,
  archiveMenu as publicArchiveMenu,
  unarchiveMenu as publicUnarchiveMenu,
  createSection as publicCreateSection,
  getItem as publicGetItem,
  listItems as publicListItems,
  updateItem as publicUpdateItem,
  createDish as publicCreateDish,
  createVariation as publicCreateVariation,
  createDraftCatalog as publicCreateDraftCatalog,
  publishDraftCatalog as publicPublishDraftCatalog,
  discardDraftCatalog as publicDiscardDraftCatalog,
  bulkCreateVariations as publicBulkCreateVariations,
  bulkUpdateItems as publicBulkUpdateItems,
  bulkCreateDishes as publicBulkCreateDishes,
  bulkCreateMenus as publicBulkCreateMenus,
  bulkUpdateMenus as publicBulkUpdateMenus,
  bulkCreateSections as publicBulkCreateSections,
  bulkUpdateSections as publicBulkUpdateSections,
  bulkArchiveMenus as publicBulkArchiveMenus,
  bulkUnarchiveMenus as publicBulkUnarchiveMenus,
} from './restaurants-catalogs-v3-catalog-catalogs.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onCatalogChanged as publicOnCatalogChanged } from './restaurants-catalogs-v3-catalog-catalogs.public.js';
import { onCatalogCreated as publicOnCatalogCreated } from './restaurants-catalogs-v3-catalog-catalogs.public.js';

export const listCatalogs: MaybeContext<
  BuildRESTFunction<typeof publicListCatalogs> & typeof publicListCatalogs
> = /*#__PURE__*/ createRESTModule(publicListCatalogs);
export const getMenu: MaybeContext<
  BuildRESTFunction<typeof publicGetMenu> & typeof publicGetMenu
> = /*#__PURE__*/ createRESTModule(publicGetMenu);
export const getSection: MaybeContext<
  BuildRESTFunction<typeof publicGetSection> & typeof publicGetSection
> = /*#__PURE__*/ createRESTModule(publicGetSection);
export const updateMenu: MaybeContext<
  BuildRESTFunction<typeof publicUpdateMenu> & typeof publicUpdateMenu
> = /*#__PURE__*/ createRESTModule(publicUpdateMenu);
export const updateSection: MaybeContext<
  BuildRESTFunction<typeof publicUpdateSection> & typeof publicUpdateSection
> = /*#__PURE__*/ createRESTModule(publicUpdateSection);
export const listMenus: MaybeContext<
  BuildRESTFunction<typeof publicListMenus> & typeof publicListMenus
> = /*#__PURE__*/ createRESTModule(publicListMenus);
export const listSections: MaybeContext<
  BuildRESTFunction<typeof publicListSections> & typeof publicListSections
> = /*#__PURE__*/ createRESTModule(publicListSections);
export const createMenu: MaybeContext<
  BuildRESTFunction<typeof publicCreateMenu> & typeof publicCreateMenu
> = /*#__PURE__*/ createRESTModule(publicCreateMenu);
export const archiveMenu: MaybeContext<
  BuildRESTFunction<typeof publicArchiveMenu> & typeof publicArchiveMenu
> = /*#__PURE__*/ createRESTModule(publicArchiveMenu);
export const unarchiveMenu: MaybeContext<
  BuildRESTFunction<typeof publicUnarchiveMenu> & typeof publicUnarchiveMenu
> = /*#__PURE__*/ createRESTModule(publicUnarchiveMenu);
export const createSection: MaybeContext<
  BuildRESTFunction<typeof publicCreateSection> & typeof publicCreateSection
> = /*#__PURE__*/ createRESTModule(publicCreateSection);
export const getItem: MaybeContext<
  BuildRESTFunction<typeof publicGetItem> & typeof publicGetItem
> = /*#__PURE__*/ createRESTModule(publicGetItem);
export const listItems: MaybeContext<
  BuildRESTFunction<typeof publicListItems> & typeof publicListItems
> = /*#__PURE__*/ createRESTModule(publicListItems);
export const updateItem: MaybeContext<
  BuildRESTFunction<typeof publicUpdateItem> & typeof publicUpdateItem
> = /*#__PURE__*/ createRESTModule(publicUpdateItem);
export const createDish: MaybeContext<
  BuildRESTFunction<typeof publicCreateDish> & typeof publicCreateDish
> = /*#__PURE__*/ createRESTModule(publicCreateDish);
export const createVariation: MaybeContext<
  BuildRESTFunction<typeof publicCreateVariation> & typeof publicCreateVariation
> = /*#__PURE__*/ createRESTModule(publicCreateVariation);
export const createDraftCatalog: MaybeContext<
  BuildRESTFunction<typeof publicCreateDraftCatalog> &
    typeof publicCreateDraftCatalog
> = /*#__PURE__*/ createRESTModule(publicCreateDraftCatalog);
export const publishDraftCatalog: MaybeContext<
  BuildRESTFunction<typeof publicPublishDraftCatalog> &
    typeof publicPublishDraftCatalog
> = /*#__PURE__*/ createRESTModule(publicPublishDraftCatalog);
export const discardDraftCatalog: MaybeContext<
  BuildRESTFunction<typeof publicDiscardDraftCatalog> &
    typeof publicDiscardDraftCatalog
> = /*#__PURE__*/ createRESTModule(publicDiscardDraftCatalog);
export const bulkCreateVariations: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateVariations> &
    typeof publicBulkCreateVariations
> = /*#__PURE__*/ createRESTModule(publicBulkCreateVariations);
export const bulkUpdateItems: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateItems> & typeof publicBulkUpdateItems
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateItems);
export const bulkCreateDishes: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateDishes> &
    typeof publicBulkCreateDishes
> = /*#__PURE__*/ createRESTModule(publicBulkCreateDishes);
export const bulkCreateMenus: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateMenus> & typeof publicBulkCreateMenus
> = /*#__PURE__*/ createRESTModule(publicBulkCreateMenus);
export const bulkUpdateMenus: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateMenus> & typeof publicBulkUpdateMenus
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateMenus);
export const bulkCreateSections: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateSections> &
    typeof publicBulkCreateSections
> = /*#__PURE__*/ createRESTModule(publicBulkCreateSections);
export const bulkUpdateSections: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateSections> &
    typeof publicBulkUpdateSections
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateSections);
export const bulkArchiveMenus: MaybeContext<
  BuildRESTFunction<typeof publicBulkArchiveMenus> &
    typeof publicBulkArchiveMenus
> = /*#__PURE__*/ createRESTModule(publicBulkArchiveMenus);
export const bulkUnarchiveMenus: MaybeContext<
  BuildRESTFunction<typeof publicBulkUnarchiveMenus> &
    typeof publicBulkUnarchiveMenus
> = /*#__PURE__*/ createRESTModule(publicBulkUnarchiveMenus);
/**
 * Triggered when a catalog is changed.
 *
 * > __Note:__ The webhook doesn't return information about what has changed. In order to update an external POS upon changes to a Wix Restaurants catalog you may need to create your own logic to identify the changes.
 * @deprecated
 */
export const onCatalogChanged: BuildEventDefinition<
  typeof publicOnCatalogChanged
> &
  typeof publicOnCatalogChanged = createEventModule(publicOnCatalogChanged);
/**
 * Triggered when a catalog is created.
 *
 * > __Note:__ The webhook doesn't return information about the entities belonging to the catalog. You may need to create your own logic to retrieve the catalog's content.
 * @deprecated
 */
export const onCatalogCreated: BuildEventDefinition<
  typeof publicOnCatalogCreated
> &
  typeof publicOnCatalogCreated = createEventModule(publicOnCatalogCreated);

export {
  FulfillmentType,
  Platform,
  DayOfWeek,
  Type,
  ItemType,
  DiscountType,
  DiscountPlatform,
  SortOrder,
  WebhookIdentityType,
} from './restaurants-catalogs-v3-catalog-catalogs.universal.js';
export {
  Catalog,
  InvalidateCache,
  InvalidateCacheGetByOneOf,
  App,
  Page,
  URI,
  File,
  CustomTag,
  Pages,
  URIs,
  CatalogUpdated,
  Item,
  Money,
  Labels,
  VisibilityCriteria,
  Availability,
  TimePeriod,
  SpecialHourPeriod,
  DishOptions,
  DishOption,
  DishOptionMethodOneOf,
  DishOptionItem,
  Selection,
  Extras,
  Deselection,
  Section,
  SectionItemIds,
  Menu,
  MenuSectionIds,
  Discount,
  DiscountValueOneOf,
  DiscountApplyToFilterOneOf,
  SectionIds,
  ItemIds,
  DiscountCondition,
  Coupon,
  PublishCatalogUpdated,
  IndexCacheCmd,
  CatalogChanged,
  ListCatalogsRequest,
  Sorting,
  Paging,
  ListCatalogsResponse,
  GetMenuRequest,
  GetMenuResponse,
  GetSectionRequest,
  GetSectionResponse,
  UpdateMenuRequest,
  UpdateMenuResponse,
  V3UpdateSectionRequest,
  UpdateSectionResponse,
  ListMenusRequest,
  ListMenusResponse,
  ListSectionsRequest,
  ListSectionsResponse,
  CreateMenuRequest,
  CreateMenuResponse,
  ArchiveMenuRequest,
  ArchiveMenuResponse,
  UnarchiveMenuRequest,
  UnarchiveMenuResponse,
  ArchiveSectionRequest,
  ArchiveSectionResponse,
  RemoveDishFromSectionRequest,
  RemoveDishFromSectionResponse,
  V3CreateSectionRequest,
  CreateSectionResponse,
  GetItemRequest,
  GetItemResponse,
  ListItemsRequest,
  ListItemsResponse,
  UpdateItemRequest,
  UpdateItemResponse,
  V3CreateDishRequest,
  CreateDishResponse,
  CreateVariationRequest,
  CreateVariationResponse,
  BulkCreateVariationsRequest,
  NewVariation,
  BulkCreateVariationsResponse,
  BulkItemResult,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  BulkArchiveMenusRequest,
  BulkArchiveMenusResponse,
  BulkMenuResult,
  MenuUpdated,
  Empty,
  BulkCreateDishesRequest,
  CreateDishRequest,
  BulkCreateDishesResponse,
  BulkCreateSectionsRequest,
  CreateSectionRequest,
  BulkCreateSectionsResponse,
  BulkSectionResult,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  CreateDraftCatalogRequest,
  CreateDraftCatalogResponse,
  PublishDraftCatalogRequest,
  PublishDraftCatalogResponse,
  DiscardDraftCatalogRequest,
  DiscardDraftCatalogResponse,
  BulkUpdateItemsRequest,
  BulkUpdateItemsResponse,
  BulkCreateMenusRequest,
  BulkCreateMenusResponse,
  BulkUpdateMenusRequest,
  BulkUpdateMenusResponse,
  BulkUpdateSectionsRequest,
  UpdateSectionRequest,
  BulkUpdateSectionsResponse,
  BulkUnarchiveMenusRequest,
  BulkUnarchiveMenusResponse,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  CatalogChangedEnvelope,
  CatalogCreatedEnvelope,
  ListCatalogsOptions,
  GetMenuIdentifiers,
  GetSectionIdentifiers,
  UpdateMenuIdentifiers,
  UpdateMenuOptions,
  UpdateSectionIdentifiers,
  UpdateSectionOptions,
  ListMenusOptions,
  ListSectionsOptions,
  ArchiveMenuIdentifiers,
  UnarchiveMenuIdentifiers,
  CreateSectionIdentifiers,
  GetItemIdentifiers,
  GetItemOptions,
  ListItemsOptions,
  UpdateItemIdentifiers,
  UpdateItemOptions,
  CreateDishIdentifiers,
  BulkCreateVariationsOptions,
  BulkUpdateItemsOptions,
  BulkCreateDishesOptions,
  BulkCreateMenusOptions,
  BulkUpdateMenusOptions,
  BulkCreateSectionsOptions,
  BulkUpdateSectionsOptions,
  BulkArchiveMenusOptions,
  BulkUnarchiveMenusOptions,
} from './restaurants-catalogs-v3-catalog-catalogs.universal.js';
export {
  FulfillmentTypeWithLiterals,
  PlatformWithLiterals,
  DayOfWeekWithLiterals,
  TypeWithLiterals,
  ItemTypeWithLiterals,
  DiscountTypeWithLiterals,
  DiscountPlatformWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './restaurants-catalogs-v3-catalog-catalogs.universal.js';
